/* ============================================================
   Product info section — mobile accordion.
   First block is open by default. Multiple blocks can be open
   simultaneously (no exclusive radio behaviour). Desktop is
   always-expanded; the JS no-ops above 1023px.
   ============================================================ */
(function () {
  'use strict';

  const accordions = document.querySelectorAll('[data-zc-accordion]');
  if (!accordions.length) return;

  const mq = window.matchMedia('(max-width: 1023px)');

  const apply = () => {
    accordions.forEach((accordion) => {
      const items = accordion.querySelectorAll('[data-zc-accordion-item]');
      items.forEach((item, i) => {
        const head = item.querySelector('[data-zc-accordion-head]');
        if (!head) return;

        if (mq.matches) {
          const open = i === 0;
          item.classList.toggle('is-open', open);
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        } else {
          item.classList.add('is-open');
          head.setAttribute('aria-expanded', 'true');
        }

        if (head.dataset.zcBound) return;
        head.dataset.zcBound = '1';
        head.addEventListener('click', () => {
          if (!mq.matches) return;
          const open = item.classList.toggle('is-open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  };

  apply();
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', apply);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(apply);
  }
})();
